const colors = {
  semiTransparentBlack: '#00000033',
  black: '#000000',
  white: '#FFFFFF',
  smokeyWhite: '#F1F1F1',
  greyWhite: '#F8F8F8',
  lightestGrey: '#EEEEEE',
  lightGrey: '#CCCCCC',
  midLightGrey: '#A4A4A8',
  midBlue: '#0073A8',
  midGrey: '#A0A0A0',
  grey: '#C4C4C4',
  mediumGrey: '#979797',
  darkGrey: '#767676',
  veryDarkGrey: '#231F20',
  darkestGrey: '#363636',
  purple: '#B6359C',
  darkPurple: '#3B00AD',
  veryDarkPurple: '#170645',
  blue: '#0779E4',
  darkBlue: '#1B2457',
  veryDarkBlue: '#0B1C2F',
  customBlue: '#3478f6',
  pink: '#DE1F70',
  darkPink: '#AC2F64',
  green: '#92E3A9',
  fernGreen: '#4B9A6D',
  lightGreen: '#89C8AA',
  mediumGreen: '#89C8AA',
  darkGreen: '#0E2C38',
  veryDarkGreen: '#0DAA04',
  forestGreen: '#285D49',
  pastelGreen: '#D5EEDE',
  darkestGreen: '#162C15',
  lilac: '#F9FAFF',
  avoGreen: '#89C8AA',
  gray98: '#FAFAFA',
  neutralBlack: '#0B0B0B',
  smokeGrey: '#F7F7F7',
  smokeBlack: '#323A68',
  successGreen: '#52AE67',
  verizonRed: '#F90016',
  verizonGrey: '#7B7777',
  discountsPurple: '#8A2387',
  samsungActivationPillDarkGrey: '#C1C1C1',
  semiDarkGrey: '#868686',
  greyBackground: '#F3F3ED',
  lightGreyBackground: '#F5F6F8',
  greyText: '#75717F',
  darkBackground: '#232323',
  orange: '#FF4822',
  navyBlueText: '#36164A',
  textLink: '#9E099E',
  lightBlueGrey: '#B2BAD3',
  navy: '#312783',
  gold: '#FCC248',
  magenta: '#951B81',
  brightGreen: '#76B82A',
  blueLightCardPrimary: '#001b80',
};

export default colors;
